<template>
   <div v-if="listNotification" class="">
      <div v-for="(item, index) in listNotification" :key="index" :class="['d-flex flex-wrap item-notf ', { 'unread': !item.read_at } ]" @click="handleOpenNotif(item)">
        <div class="avatar-notf">
          <img v-if="item?.user?.avatar" class="rounded-circle border-color-avatar" :src="upload(item?.user?.avatar,'avatar')" alt="">
          <img v-else src="/images/nof-img.png" alt="No Image">
          <i class="ri-notification-3-line icon-notf"></i>
        </div>
        <div class="content-notf">
          <div class="title-notf">
              <span>{{item.title}} </span>
              <div class="">
              {{ item?.user?.name }} {{item.content}} <span v-if="item.group?.id" class="notif-name-group">{{ item.group?.name }}</span>
              </div>
          </div>
          <div class="time-notf">
            <span>{{ this.timeAgo(item.created_at) }}</span> 
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {  ref } from "vue";
import NotificationsService from "@crm/src/services/notifications.service";
export default {
  props: {
    listNotification:{
      type: Object,
    },
    service:{
      type: Object,
    },
    userId:{
      type: String,
    }
  },
  data() {
    return {
      data: ref([]),
    };
  },
  watch: {
    
  },
  created() {
   this.data={...this.listNotification}
  },
  methods: {
    async handleOpenNotif(item){
      try {
        const dataUpdate = {
          'user_id':this.userId,
          'notification_id':item.id,
        }
        const rs = await NotificationsService.updateRead(dataUpdate);
        if (rs.data.success == false) {
          console.log('error');
        } else {
          alert("home")
          window.location.href=`/${item.path}/${item.id_post}`;
        }
      }catch (error) {
        console.log('error',error);
      } 
    }
  }
};
</script>
<style>

.item-notf{
  margin: 0px 0;
  padding: 10px;
  opacity: 0.8;
  width: 280px;
}
.item-notf:hover{
  background: #f3f3f3;
}
.item-notf.unread {
  opacity: 1;
}
.avatar-notf{
  width: 50px;
  position: relative;
}
.avatar-notf img{

}
.avatar-notf .icon-notf{
  position: absolute;
  right: -5px;
  bottom: -2px;
  width: 20px;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  background: #a7a7a7;
  border-radius: 50%;
  text-align: center;
  color:#fff;
}
.item-notf.unread .avatar-notf .icon-notf{
  background: #00cf00;
}
.content-notf{
  width: calc(100% - 50px);
  padding: 0 0 0 10px;
}
.title-notf{

}
.title-notf span{
  font-weight: bold;
}
.time-notf{

}
.time-notf span{
  color: #5aa7ff;
}
.border-color-avatar{
  border: 1px solid #5aa7ff;
}
.notif-name-group{
  color: #5aa7ff;
}
</style>